module.exports = __webpack_public_path__ + "img/logogw.8c400a98.png";